import { graphql } from '@/graphql/generated/seller';

export const skusQuery = graphql(`
  query SkusQuery($limit: Int!, $offset: Int!, $where: SkusBoolExp!, $orderBy: [SkusOrderByExp!]!) {
    skus(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      description
      barcode
      type
      height
      width
      length
      dimensionUnit
      weight
      weightUnit
      archivedAt
    }
    skusAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
